import React from "react";
import { Card, CardMedia, CardContent, Typography, Grid, Container, Box,Button } from "@mui/material";
import { motion } from "framer-motion";
import vegepow from './images/vegetable-powders-500x500_001.webp'
import dehyveg from './images/dried-vegetables-chips-beets-carrots-600nw-2199421229.webp'
import spicesimg from './images/spicepr.jpg'
import garlicimg from './images/garlicpowder.jpg'
import whiteonionimg from './images/dehydrated-white-onion-chopped-500x500.webp'
import pinkonionimg from './images/pinkonionminced.jpg'
import redonionimg from './images/red-onion-chopped-2-scaled-500x500.webp'
import friedonionimg from './images/friedcoatedmin.jpg'
import { useNavigate } from "react-router-dom";


const productOptions = [
  {
    title: "Onion Products (White)",
    description: "Premium white onion powder known for its sharp flavor and culinary versatility.",
    img: whiteonionimg,
    redirect: "/detailed-products-white-onion"
  },
  {
    title: "Onion Products (Pink)",
    description: "Aromatic pink onion powder offering mild sweetness and rich taste.",
    img: pinkonionimg,
    redirect: "/detailed-products-pink-onion"
  },
  {
    title: "Onion Products (Red)",
    description: "Strong and flavorful red onion powder perfect for spice blends and seasoning.",
    img: redonionimg,
    redirect: "/detailed-products-red-onion"
  },
  {
    title: "Fried Onions",
    description: "Crispy and golden fried onions ideal for garnishing and ready-to-cook meals.",
    img: friedonionimg,
    redirect: "/detailed-products-fried-onions"
  },
  {
    title: "Garlic Products",
    description: "Fresh Garlic Products harvested with care from the best of Indian farms.",
    img: garlicimg,
    redirect: "/detailed-products-garlic"
  },
  {
    title: "Vegetable Powders",
    description: "Finely milled powders from fresh vegetables for culinary and nutritional use.",
    img: vegepow,
    redirect: "/detailed-products-vegetable-powders-and-spices"
  },
  {
    title: "Dehydrated Vegetables",
    description: "Naturally dried vegetables preserving nutrients and taste for long shelf life.",
    img: dehyveg,
    redirect: "/detailed-products-vegetable-powders-and-spices"
  },
  {
    title: "Spices",
    description: "Authentic Indian spices, carefully sourced and exported globally.",
    img: spicesimg,
    redirect: "/detailed-products-vegetable-powders-and-spices"
  }
];


const TradingSolutions = () => {
  const navigate = useNavigate();


  return (
    <Container
      maxWidth={false}
      sx={{
        width: "100%",
        background: 'linear-gradient(135deg,rgb(0, 0, 0),rgb(0, 0, 0))',
        color: "white",
        padding: "40px",
        textAlign: "center",
      }}
    >
      {/* Animated Heading */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
          Global Trading with <span style={{ color: '#D4C9B6' }}>Unispherexim</span>
        </Typography>
      </motion.div>

      <Grid container spacing={3} justifyContent="center">
  {productOptions.map((product, index) => (
    <Grid item xs={12} sm={6} md={4} key={index}>
      {/* Animated Card */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: index * 0.2 }}
      >
        <Card
          sx={{
            background: "linear-gradient(135deg,rgb(13, 14, 13),rgb(20, 33, 21))",
            color: "white",
            borderRadius: "15px",
            overflow: "hidden",
            transition: "transform 0.3s",
            "&:hover": { transform: "scale(1.05)" },
          }}
        >
          <CardMedia
            component="img"
            sx={{ minHeight: 100, maxHeight: 300 }}
            image={product.img}
            alt={product.title}
          />
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {product.title}
            </Typography>
            <Typography variant="body2" color="#D4C9B6">
              {product.description}
            </Typography>
          </CardContent>
          <Box textAlign="center" pb={2}>
            <Button
              variant="outlined"
              sx={{ margin:1,borderColor: "#D4C9B6", color: "#D4C9B6", "&:hover": { borderColor: "white", color: "white" } }}
              onClick={() => navigate(product.redirect)}
            >
              Explore
            </Button>
             <Button
              variant="outlined"
              sx={{ margin:1,borderColor: "#D4C9B6", color: "#D4C9B6", "&:hover": { borderColor: "white", color: "white" } }}
              onClick={() => navigate("/contact")}
            >
              Contact us
            </Button>
          </Box>
        </Card>
      </motion.div>
    </Grid>
  ))}
</Grid>
    </Container>
  );
};

export default TradingSolutions;
